import { Autocomplete } from '@cast/design-system';

import { useWoopWorkloadFilters } from 'features/workload-optimization';

import { verticalScalingPolicyCriterion } from '../workloads-list/searchCriteria';

import { useSearchCriterion } from '@cast/shared-search-ui';

export const VerticalScalingPolicyFilter = () => {
  const { data } = useWoopWorkloadFilters();
  const { setValue, value, clear } = useSearchCriterion(
    verticalScalingPolicyCriterion
  );
  const options = data?.scalingPolicyNames ?? [];

  return (
    <Autocomplete
      testId="vertical-scaling-policy-filter"
      inputText="Scaling policy"
      options={options}
      value={value}
      onChange={(value: string[]) => {
        if (value?.length) {
          setValue?.(value);
        } else {
          clear?.();
        }
      }}
      multiple
      checkable
      listSx={{ '& .MuiListItemText-primary': { whiteSpace: 'nowrap' } }}
      size="sm"
    />
  );
};
